import React, { useContext, useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { Menu } from 'antd'
import {
  HomeOutlined,
  UsergroupAddOutlined,
  ShopOutlined,
  ShoppingOutlined,
  IdcardOutlined,
  SettingOutlined,
  ProjectOutlined,
  CreditCardOutlined,
  WalletOutlined,
  BgColorsOutlined,
} from '@ant-design/icons'
import { menu_routes } from './Menu_routes'
import { Context, useStore } from '../context'

function MenuView() {
  const [state] = useContext(Context)
  const { hasPermissions } = useStore(state)
  const history = useHistory()
  const [key, setKey] = useState("")

  useEffect(() => {
    let actualPath = menu_routes.find(m => m.route === history.location.pathname)
    if (hasPermissions(actualPath.profilePermissions)) {
      setKey(actualPath.key)
    } else {
      let path = menu_routes.find(m => hasPermissions(m.profilePermissions))
      setKey(path.key)
    }
    // eslint-disable-next-line
  }, [])

  let returnIcon = iconName => {
    switch (iconName) {
      case 'enterprises':
        return <HomeOutlined style={{ color: 'var(--tendero-green)', fontSize: '18px' }} />
      case 'users':
        return <UsergroupAddOutlined style={{ color: 'var(--tendero-green)', fontSize: '18px' }} />
      case 'shops':
        return <ShopOutlined style={{ color: 'var(--tendero-green)', fontSize: '18px' }} />
      case 'products':
        return <ShoppingOutlined style={{ color: 'var(--tendero-green)', fontSize: '18px' }} />
      case 'clients':
        return <IdcardOutlined style={{ color: 'var(--tendero-green)', fontSize: '18px' }} />
      case 'configurations':
        return <SettingOutlined style={{ color: 'var(--tendero-green)', fontSize: '18px' }} />
      case 'inventory':
        return <ProjectOutlined style={{ color: 'var(--tendero-green)', fontSize: '18px', transform: 'rotate(-90deg)' }} />
      case 'pos':
        return <CreditCardOutlined style={{ color: 'var(--tendero-green)', fontSize: '18px' }} />
      case 'cashRegister':
        return <WalletOutlined style={{ color: 'var(--tendero-green)', fontSize: '18px' }} />
      case 'personalizacion':
        return <BgColorsOutlined style={{ color: 'var(--tendero-green)', fontSize: '18px' }} />
      default:
        return <React.Fragment></React.Fragment>
    }
  }

  return (
    <Menu mode="inline" selectedKeys={[key]} style={{ height: '100%', paddingTop: '20px' }}>
      {menu_routes &&
        menu_routes.length > 0 &&
        menu_routes.map((option, i) => (
          hasPermissions(option.profilePermissions) && (state.auth.role_id === 1 || ((!option.country || (state.auth.company?.country?.name === 'Honduras' && state.auth.company?.allow_fel)))) && (
            <Menu.Item key={option.key} icon={returnIcon(option.icon)} onClick={() => setKey(option.key)} >
              <Link to={option.route}>
                <span style={{ paddingLeft: '13px' }}>{option.name}</span>
              </Link>
            </Menu.Item>
          )
        ))}
    </Menu>
  )
}

export default MenuView
